module.exports = __webpack_public_path__ + "static/media/luvas-borracha.339cde26.png";